import { FetchSideError } from '@app/code/src/types/flowFetch'
import { getEnPaymentMessage } from '@app/common/src/components/PlanPurchaseExperience/usePaymentMethodError'
import { getServerSideErrorType } from '@dtx-company/logger'

export const subscriptionServiceV3ErrorHandler = async (res: Response): Promise<void> => {
  const body = res.json ? await res.json() : res.statusText
  const message = body && body.message ? body.message : JSON.stringify(body)
  const type = getServerSideErrorType(res.status)
  const fetchError = new FetchSideError({
    type,
    endpoint: res.url,
    message: message,
    name: 'API request Error',
    status: res.status,
    statusText: res.statusText,
    data: body
  })

  const displayedMessage = await getEnPaymentMessage(fetchError)
  throw new FetchSideError({
    type,
    endpoint: res.url,
    message: displayedMessage,
    code: message,
    name: 'Subscription API request Error',
    status: res.status,
    statusText: res.statusText,
    data: body
  })
}
